import { Injectable } from '@angular/core';
import {
    Router,
    ActivatedRouteSnapshot,
    RouterStateSnapshot
} from '@angular/router';
import { CanActivate } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private auth: AuthService, private router: Router) { }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (this.auth.authenticated) {
            let nextComponent = next.component as any;
            switch (nextComponent.name) {
                case 'ProductEditComponent':
                    return this.auth.hasPermission('write:products');

                case 'ProductsComponent':
                    return this.auth.hasPermission('read:products');

                case 'VersionEditComponent':
                    return this.auth.hasPermission('write:versions');

                case 'VersionsComponent':
                    return this.auth.hasPermission('read:versions');

                default:
                    return true;
            }
        } else {
            // Save URL to redirect to after login and fetching profile to get roles
            localStorage.setItem('auth_redirect', state.url);
            this.auth.login();
            return false;
        }
    }
}



// WEBPACK FOOTER //
// ./Client/app/shared/auth.guard.ts